@for (option of options(); track option.value) {
  <button
    type="button"
    role="radio"
    [attr.aria-checked]="value() === option.value"
    [class.msa-btn-group__item--active]="value() === option.value"
    (click)="selectOption(option.value)"
  >
    @if (option.icon) {
      <span class="msa-btn-group__icon">{{ option.icon }}</span>
    }
    <span class="msa-btn-group__label">{{ option.label }}</span>
  </button>
}
